module.exports = __webpack_public_path__ + "img/outline-description.5e7d3e85.svg";